import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import CustomForm from 'src/components/CustomForm';
import { ADD_GENRE_FIELDS } from 'src/utils/constants';
import { Form } from 'antd';
import useWindowSize from 'src/utils/hooks//useWindowSize';
import { useDispatch, useSelector } from 'react-redux';
import genreActions from 'src/redux/actions/genreActions';
import Loading from 'src/components/Loading';
import genreSelectors from 'src/redux/selectors/genreSelectors';
import { getRandomHexColor } from 'src/utils/helpers';

const ModalAddGenre = ({ visible, onCancel, editingGenre }) => {
  const dispatch = useDispatch();
  const { windowHeight } = useWindowSize();
  const [form] = Form.useForm();
  const loading = useSelector(genreSelectors.loading);

  const fetchGenres = () => {
    dispatch(genreActions.fetchGenres());
  };

  useEffect(() => {
    visible && form.setFieldValue('name', editingGenre?.name || '');
    visible && form.setFieldValue('color', editingGenre?.color || getRandomHexColor());
  }, [visible]);

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        if (editingGenre) {
          dispatch(genreActions.editGenre({ ...values, genreId: editingGenre.id }, () => {
            form.resetFields();
            onCancel();
            fetchGenres();
          }));
        } else {
          dispatch(genreActions.addGenre(values, () => {
            form.resetFields();
            onCancel();
            fetchGenres();
          }));
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  }

  return (
    <Modal
      title={editingGenre ? "Edit genre" : "Add genre"}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={false}
      centered
      bodyStyle={{ maxHeight: windowHeight - 200, overflowY: 'auto' }}
      destroyOnClose
    >
      <Loading loading={loading} />
      <CustomForm form={form} fields={ADD_GENRE_FIELDS} autoComplete='off' layout='vertical' />
    </Modal>
  )
}

export default ModalAddGenre;